<template lang="html">

    <div class="cover-popup row-center -recordar" @keyup.esc="$emit('close')">

        <span class="close-cover" @click="$emit('close')"></span>

        <div class="popup">
            <a class="close" @click="$emit('close')">✕</a>
            <h3 class="title-pop">Recuperar contraseña</h3>

            <div class="contenedor-input">
                <label v-if="type != 'empresas'" for="">Introduce el email asociado en tu cuenta de estudiante/egresado</label>
                <label v-else for="">Por favor indíquenos su usuario y le enviaremos un correo con su contraseña</label>
                <input type="text" v-model="value">
            </div>
            <button class="btn" :loading="loading" @click="send">Recordar contraseña</button>
        </div>
    </div>

</template>

<script lang="js">

    import {mapActions} from 'vuex';

    export default {
        name: 'formulario-recordar',
        mounted(){
            this.type = this.$route.params.id
        },
        props : ['type'],
        data(){
            return{
                loading : false,
                value : ''
            }
        },
        methods : {
            ...mapActions(['recordarPass']),
            send(){
                this.loading = true;

                let data = {
                    valor : this.value,
                    type : this.type
                }

                this.recordarPass(data).then(r => {
                    this.loading = false;
                    this.$emit('close');
                }).catch(r => {
                    this.loading = false;
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/view-parts/login/popup-recuperacion-pass.vue